import { Container } from "react-bootstrap";
import { Helmet, HelmetProvider } from "react-helmet-async";
import skills from "../data/skillsData";
import "./CSS/Skills.css";

function Skills() {
  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>Skills | Lee</title>
        </Helmet>
      </HelmetProvider>
      <Container fluid className="skills-wrapper">
        <div className="skills-left animate__animated animate__zoomIn">
          <h3>Skills</h3>
          <h4>
            ───&nbsp;&nbsp;Page <strong>03</strong>
          </h4>
        </div>
        <div className="skills-right">
          {skills.map((skillCategory, index) => (
            <div key={index} className="row my-4 animate__animated animate__flipInX animate_slow">
              <div className="col">
                
                {skillCategory.icons.map((icon, idx) => (
                  <i key={idx} className={icon.className} title={icon.title}></i>
                ))}
              </div>
            </div>
          ))}
        </div>
      </Container>
    </>
  );
}

export default Skills;
